import React from 'react'
import { Input, Card, Button } from 'antd'
import { PlusOutlined, DeleteOutlined } from '@ant-design/icons'
import { useFormikContext, FieldArray } from 'formik'
import { FormField } from './shared'
import { useFieldPath } from './TabContext'
import { get } from 'lodash'

const { TextArea } = Input

export const MobileCTA: React.FC = () => {
  const { values, setFieldValue } = useFormikContext<any>()

  const textPath = useFieldPath('sections.mobileCTA.text')

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setFieldValue(e.target.name, e.target.value)
  }

  return (
    <Card>
      <FormField>
        <label>Texto</label>
        <TextArea
          name={textPath}
          value={get(values, textPath, '')}
          onChange={handleChange}
          rows={3}
          placeholder="Texto do CTA mobile"
        />
      </FormField>
    </Card>
  )
}
